var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherReportDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 23.8L18.4 23.3C16.4 21.4 15 20.2 15 18.7C15 17.5 16 16.5 17.2 16.5C17.9 16.5 18.6 16.8 19 17.3C19.4 16.8 20.1 16.5 20.8 16.5C22 16.5 23 17.4 23 18.7C23 20.2 21.6 21.4 19.6 23.3L19 23.8ZM6 22.5C5.46957 22.5 4.96086 22.2893 4.58579 21.9142C4.21071 21.5391 4 21.0304 4 20.5V4.5C4 3.39 4.89 2.5 6 2.5H7V9.5L9.5 8L12 9.5V2.5H18C18.5304 2.5 19.0391 2.71071 19.4142 3.08579C19.7893 3.46086 20 3.96957 20 4.5V13.58L19 13.5C17.947 13.5008 16.9128 13.7785 16.0011 14.3052C15.0893 14.8319 14.3321 15.5891 13.8053 16.5008C13.2785 17.4125 13.0007 18.4468 12.9998 19.4997C12.9989 20.5527 13.2748 21.5874 13.8 22.5H6Z",
    fill: "#5474C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherReportDoc);
export default __webpack_public_path__ + "static/media/other-report-doc.8d0afa7d1bb8ec8cc5748bd392c1ee5a.svg";
export { ForwardRef as ReactComponent };